import { ENUMS } from 'services/consts';

import StoreAdvancedSettingsForm from '../Forms/StoreAdvancedSettingsForm';

const ZidForm = () => <StoreAdvancedSettingsForm enumName={ENUMS.ZID_CREDENTIALS_STATUSES} showStoreUrl />;

export default ZidForm;
